// const posturl = 'http://huaxiahelp-api.whir.design:3034/';
const posturl = 'http://guanli.huaxiahelp.cn/';
const sys_tel = '022-87636202';
const sys_bq='版权所有：天津市华夏器官移植救助基金会&nbsp;&nbsp;津ICP备13003238号<br>天津市第一中心医院移植中心&nbsp;&nbsp;高伟主任：13920128996';
export default {
  posturl,
  sys_tel,
  sys_bq
};



// WEBPACK FOOTER //
// ./src/store/globalVariable.js